enum PublishingEventType {
	UnPublish = 'unpublish',
	Publish = 'publish'
}

export default PublishingEventType;
